export default __webpack_public_path__ + "static/media/icon-verified-provider.787b7d3e.svg";